import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";

const ConfigContext = createContext<any | null>(null);
const useConfigContext = () => useContext(ConfigContext);

interface AuxProps {
  children: ReactNode;
}

const ConfigProvider = ({ children }: AuxProps) => {
  const [data, setData] = useState<any | null>([]);
  const [configLoaded, setConfigLoaded] = useState<boolean>(false);
  const [googleMapsApiKey, setGoogleMapsApiKey] = useState<string>("");

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    fetch("/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        // console.log(response);
        if (response.status === 200) return response.json();
        else return "{}";
      })
      .then((myJson: any) => {
        console.log("config data: ", myJson);
        setData(myJson);
      });
  };

  useEffect(() => {
    if (data.GOOGLE_MAPS_API_KEY) {
      setGoogleMapsApiKey(data.GOOGLE_MAPS_API_KEY || "");
    }
    setConfigLoaded(true);
  }, [data]);

  return (
    <ConfigContext.Provider
      value={{
        configLoaded,
        googleMapsApiKey,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};

export { ConfigProvider, useConfigContext };
